<template>
  <template v-if="$page.props.user.roles.includes(role)">
    <slot />
  </template>
</template>

<script>
export default {
  props: {
    role: { type: String, default: 'tech' },
  },
};
</script>
